import { render, staticRenderFns } from "./dichiarazioniMobile.vue?vue&type=template&id=0f7e93e0&scoped=true&"
import script from "./dichiarazioniMobile.vue.ts?vue&type=script&lang=ts&"
export * from "./dichiarazioniMobile.vue.ts?vue&type=script&lang=ts&"
import style0 from "./dichiarazioniMobile.vue?vue&type=style&index=0&id=0f7e93e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f7e93e0",
  null
  
)

export default component.exports